<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>所属银行：</span>
        <Input v-model="search.bank" type="text" style="width:100px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>对方户名：</span>
        <Input v-model="search.companyName" style="width:150px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>对方账号：</span>
        <Input v-model="search.companyAccount" style="width:150px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>金额：</span>
        <Input v-model="search.amount[0]" style="width:80px;margin-right:5px;"></Input>
        <span> - </span>
        <Input v-model="search.amount[1]" style="width:80px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>交易日期：</span>
        <DatePicker v-model="search.dealDate" type="daterange" placement="bottom-end" style="width: 200px;margin-right:5px"></DatePicker>
      </div>
      <div class="search">
        <span>领取时间：</span>
        <DatePicker v-model="search.receiveDate" type="daterange" placement="bottom-end" style="width: 200px;margin-right:5px"></DatePicker>
      </div>
      <div class="search">
        <span>状态：</span>
        <Select v-model="search.state" style="width:100px;margin-right:5px;">
          <Option value="0" label="未退"></Option>
          <Option value="1" label="已退"></Option>
          <Option :value="''" label="全部"></Option>
        </Select>
      </div>
      <Button type="primary" @click="searchDeposit" style="margin-right:5px;">搜索</Button>
      <!-- <span style="color:#ed4014;padding:0 20px;font-weight:600;">请注意：状态是给予财务查询的，领取保证金只需领取一条且领取详情只确认一条，请不要重复领取多条！</span> -->
    </div>
    <Table :columns="columns" :data="depositDetails" style="min-width:1200px;"></Table>
    <Page :total="total" show-elevator show-total @on-change="pageChange"></Page>
    <!-- 退保信息 -->
    <Modal title="退保信息" v-model="refundMessage" width="800px" class="refund-modal">
      <Button type="primary" @click="addRefund" style="margin-bottom:10px">添加退保信息
      </Button>
      <Table :columns="refundColumns" :data="refundList"></Table>
      <div slot="footer"></div>
    </Modal>
    <!-- 添加退保信息 -->
    <Modal title="添加退保信息" v-model="refundDepositVisible" width="600px" class="refund-modal">
      <Form :label-width="110" inline>
        <FormItem label="保证金退还金额" required>
          <Input style="width:120px;" v-model="refundDepositForm.amount"></Input>
        </FormItem>
        <FormItem label="退款日期" :label-width="80">
          <DatePicker v-model="refundDepositForm.date" type="date" style="width: 120px"></DatePicker>
        </FormItem>
        <FormItem label="保证金退款方式" required>
          <Select v-model="refundDepositForm.refundType" style="width:120px">
            <Option v-for="item in refundTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="退保证金OA单号" required :label-width="120">
          <Input style="width:120px;" v-model="refundDepositForm.oaNumber"></Input>
        </FormItem>
        <FormItem label="迟退或未退原因">
          <Input v-model="refundDepositForm.reason" readonly style="width: 300px"></Input>
        </FormItem>
        <FormItem label="备注">
          <Input style="width:300px;" v-model="refundDepositForm.comment"></Input>
        </FormItem>
        <FormItem label="退保户名">
          <Input style="width:300px;" v-model="refundDepositForm.companyName"></Input>
        </FormItem>
        <FormItem label="退保账号">
          <Input style="width:300px;" v-model="refundDepositForm.companyAccount"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="refundDepositVisible=false">取消</Button>
        <Button type="primary" @click="submitRefund">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'

export default {
  name: 'receiveDeposit',
  computed: {
    confirmPermission () {
      return this.$store.getters['session/hasRoles']('退保证金')
    }
  },
  data() {
    return {
      refundDepositVisible: false,
      depositDetails: [],
      columns: [
        {
          title: '所属银行',
          key: 'bank',
          width: 110
        },
        {
          title: '对方户名',
          key: 'ghfAccountName'
        },
        {
          title: '对方账号',
          key: 'ghfAccount'
        },
        {
          title: '金额',
          key: 'amount',
          width: 80
        },
        {
          title: '摘要',
          key: 'digest'
        },
        {
          title: '交易日期',
          key: 'dealTime',
          render: (h, params) => {
            let time = '无'
            if (params.row.dealTime) {
              time = params.row.dealTime.split('T')[0]
            }
            return h('div', time)
          },
          width: 100
        },
        {
          title: '备注',
          key: 'comment'
        },
        {
          title: '是否已退',
          width: 100,
          align: 'center',
          render: (h, params) => {
            if (params.row.refundMargin.length > 0) {
              return h('div', '是')
            } else {
              return h('div', '否')
            }
          }
        },
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.refundDeposit(params.row)
                  }
                }
              }, '退保证金')]
            )
            return h('div', resultArray)
          }
        }
      ],
      search: {
        bank: '',
        companyName: '',
        companyAccount: '',
        amount: ['', ''],
        dealDate: [],
        receiveDate: [],
        state: ''
      },
      total: 0,
      currentPage: 1,
      selectDeposit: {},
      refundDepositForm: {
        amount: '',
        date: '',
        day: '',
        refundType: '工商银行',
        oaNumber: '',
        reason: '异常退款',
        comment: '',
        companyName: '',
        companyAccount: ''
      },
      refundTypes: [
        {
          value: '工商银行',
          label: '工商银行'
        },
        {
          value: '兴业银行',
          label: '兴业银行'
        },
        {
          value: '建设银行',
          label: '建设银行'
        },
        {
          value: '光大银行',
          label: '光大银行'
        },
        {
          value: '广发银行',
          label: '广发银行'
        },
        {
          value: '农业银行',
          label: '农业银行'
        },
        {
          value: '惠州工商银行',
          label: '惠州工商银行'
        },
        {
          value: '茂名工商银行',
          label: '茂名工商银行'
        },
        {
          value: '清远工商银行',
          label: '清远工商银行'
        },
        {
          value: '云浮工商银行',
          label: '云浮工商银行'
        },
        {
          value: '湛江工商银行',
          label: '湛江工商银行'
        },
        {
          value: '阳江工商银行',
          label: '阳江工商银行'
        },
        {
          value: '河源广发银行',
          label: '河源广发银行'
        },
        {
          value: '清远广发银行',
          label: '清远广发银行'
        },
        {
          value: '惠州广发银行',
          label: '惠州广发银行'
        },
        {
          value: '茂名广发银行',
          label: '茂名广发银行'
        },
        {
          value: '云浮广发银行',
          label: '云浮广发银行'
        },
        {
          value: '湛江广发银行',
          label: '湛江广发银行'
        },
        {
          value: '阳江广发银行',
          label: '阳江广发银行'
        },
        {
          value: '揭阳广发银行',
          label: '揭阳广发银行'
        },
        {
          value: '四川广发银行',
          label: '四川广发银行'
        },
        {
          value: '佛山广发银行',
          label: '佛山广发银行'
        },
        {
          value: '珠海广发银行',
          label: '珠海广发银行'
        },
        {
          value: '肇庆广发银行',
          label: '肇庆广发银行'
        },
        {
          value: '汕尾广发银行',
          label: '汕尾广发银行'
        },
        {
          value: '韶关广发银行',
          label: '韶关广发银行'
        },
        {
          value: '江门广发银行',
          label: '江门广发银行'
        },
        {
          value: '深圳交通银行',
          label: '深圳交通银行'
        },
        {
          value: '交通银行',
          label: '交通银行'
        },
        {
          value: '渤海银行',
          label: '渤海银行'
        },
        {
          value: '浦发银行',
          label: '浦发银行'
        },
        {
          value: '军工广发银行',
          label: '军工广发银行'
        },
        {
          value: '邮政储蓄银行',
          label: '邮政储蓄银行'
        }
      ],
      refundMessage: false,
      refundColumns: [
        {
          title: '所属银行',
          key: 'bankName',
          width: 110
        },
        {
          title: '对方户名',
          key: 'accountName'
        },
        {
          title: '对方账号',
          key: 'bankAccount'
        },
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.addRefund(params.row)
                  }
                }
              }, '编辑')]
            )
          }
        }
      ],
      refundList: [],
      depositId: ''
    }
  },
  mounted() {
    this.getDepositDetails(this.currentPage, this.search)
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'receiveDeposit') {
        this.getDepositDetails(this.currentPage, this.search)
      }
    }
  },
  methods: {
    async getDepositDetails(page, { bank, companyName, companyAccount, amount, dealDate, state, receiveDate }) {
      this.currentPage = page

      let bankSear = bank ? ` and bank.contains("${bank}")` : ''
      let companyNameSear = companyName ? ` and ghfAccountName.contains("${companyName}")` : ''
      let companyAccountSear = companyAccount ? ` and ghfAccount.contains("${companyAccount}")` : ''
      let amountLowerSear = (amount[0] || parseInt(amount[0]) === 0) ? ` and amount >= "${amount[0]}"` : ''
      let amountUpperSear = (amount[1] || parseInt(amount[1]) === 0) ? ` and amount <= "${amount[1]}"` : ''
      // let stateSear = state ? ` and state=="${state}"` : ''

      let end = ''
      let start = ''
      if (dealDate[0] && dealDate[1]) {
        start = formatDate(dealDate[0]).split(' ')[0]
        end = formatDate(dealDate[1]).split(' ')[0]
      }
      let dealDateSear = (start && end) ? ` and dealTime >= "${start}" and dealTime <= "${end}"` : ''

      let receiveEnd = ''
      let receiveStart = ''
      if (receiveDate[0] && receiveDate[1]) {
        receiveStart = formatDate(receiveDate[0]).split(' ')[0]
        receiveEnd = formatDate(receiveDate[1]).split(' ')[0]
      }
      let receiveDateSear = (receiveEnd && receiveStart) ? ` and editTime >= "${receiveStart}" and editTime <= "${receiveEnd}"` : ''

      let filter = bankSear + companyNameSear + companyAccountSear + companyAccountSear + amountLowerSear + amountUpperSear + dealDateSear + receiveDateSear
      filter = filter.slice(5)

      let rep = await ajax.get(requestUrls.ClMargin.getPaged, {
        params: {
          filter: filter,
          sorting: 'id desc',
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      if (rep.data.success) {
        this.depositDetails = rep.data.result.items
        this.total = rep.data.result.totalCount
      }
    },
    pageChange(page) {
      this.getDepositDetails(page, this.search)
    },
    searchDeposit() {
      this.getDepositDetails(1, this.search)
    },
    refundDeposit(deposit) {
      this.selectDeposit = deposit
      this.refundMessage = true
      this.refundList = deposit.refundMargin
    },
    addRefund(deposit) {
      this.refundDepositVisible = true
      if(deposit.id) {
        this.depositId = deposit.id  // 当前编辑保证金id
        this.refundDepositForm.amount = deposit.amount
        this.refundDepositForm.companyName = deposit.accountName
        this.refundDepositForm.companyAccount = deposit.bankAccount
        this.refundDepositForm.date = deposit.refundTime
        this.refundDepositForm.oaNumber = deposit.refundOA
        this.refundDepositForm.refundType = deposit.refundMethod
        this.refundDepositForm.day = deposit.numberDay
        this.refundDepositForm.comment = deposit.comment
        return
      }
      this.depositId = ''
      this.refundDepositForm.amount = this.selectDeposit.amount
      this.refundDepositForm.companyName = this.selectDeposit.ghfAccountName
      this.refundDepositForm.companyAccount = this.selectDeposit.ghfAccount
      this.refundDepositForm.date = ''
      this.refundDepositForm.oaNumber = ''
      this.refundDepositForm.refundType = this.selectDeposit.bank
      this.refundDepositForm.day = ''
      this.refundDepositForm.comment = ''
    },
    submitRefund() {
      if (this.refundDepositForm.amount === '') {
        this.$Message.error('金额不能为空')
        return
      }
      if (this.refundDepositForm.refundType === '') {
        this.$Message.error('退款方式不能为空')
        return
      }
      if (this.refundDepositForm.oaNumber === '') {
        this.$Message.error('OA单号不能为空')
        return
      }
      let message = this.depositId == '' ? '退保' : '修改'
      this.$Modal.confirm({
        title: '退保证金',
        content: this.depositId == '' ? '确认退此保证金？' : '确认修改？',
        onOk: async () => {
          this.$Spin.show()
          try {
            if (this.refundDepositForm.date) {
              this.refundDepositForm.date = formatDate(this.refundDepositForm.date)
            }
            let rep = await ajax.post(`/api/services/app/AbpRefundMargin/CreateOrUpdate`, {
              abpRefundMargin: {
                id: this.depositId,
                amount: this.refundDepositForm.amount,
                refundOA: this.refundDepositForm.oaNumber,
                refundMethod: this.refundDepositForm.refundType,
                numberDay: this.refundDepositForm.day,
                accountName: this.refundDepositForm.companyName,
                bankName: this.selectDeposit.reciprocalOpenAccount,  // TODO:所属银行
                bankAccount: this.refundDepositForm.companyAccount,
                refundTime: this.refundDepositForm.date,
                marginDetailId: this.selectDeposit.id,
                comment: this.refundDepositForm.comment,
                cause: this.refundDepositForm.reason
              }
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success(`${message}成功`)
              this.refundDepositVisible = false
              this.refundMessage = false
              this.getDepositDetails(this.currentPage, this.search)
            } else {
              this.$Message.error(`${message}失败`)
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error(`${message}失败`)
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  margin: 0 0 5px 0;
  .search {
    display: inline-block;
    margin: 0 5px 5px 0;
  }
}
</style>
